module.exports = __webpack_public_path__ + "static/hero-mid-enterprise-2f01c01baf494e219d1ff7266d4b3de2.svg";